import {FormDefinitionGroupModel} from '../formDefinitionGroup.model';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {FormDefinitionGroupFieldConverter} from './formDefinitionGroupField.converter';

@Injectable()
export class FormDefinitionGroupConverter extends HttpModelConverter<FormDefinitionGroupModel> {

    constructor(private fieldSummaryConverter: FormDefinitionGroupFieldConverter) {
        super();
    }

    protected createInstance(): FormDefinitionGroupModel {
        return new FormDefinitionGroupModel();
    }

    protected enrichObject(result: FormDefinitionGroupModel, src: FormDefinitionGroupModel) {
        result.fields = this.fieldSummaryConverter.convertFromArray(src.fields);
    }

}
